import React from 'react'

import '../App.css'
import '../styles/neighborhood.scss'
import '../styles/mapkey.scss'

export default function WikipediaPage(props){

    const wikiList = props.wiki;
    // props.wiki is an array of objects 
    // need to loop through array to get the items I need to generate a list of buttons
    // create a loop map
    const listGenerator = () => {        
        const baseURL = 'http://en.wikipedia.org/?curid=';
        return wikiList.map(item => {
            return (
            <a  className="btn-mapbox" 
                key={item.pageid}
                href={baseURL+item.pageid} 
                rel="noreferrer noopener" 
                target="_blank">
                {item.title}
            </a>
            )
        })
    }

    return (
        <div className="neighborhood-wiki">
            <h3 className="text-light">Wikipedia Links</h3>
                {props.wiki !== null ? <br/> : null}
                {props.wiki !== null ? <div className="wiki-list">{listGenerator()}</div> : <h2 className="text-bold">N/A</h2> }
        </div>
    )
}